export default "__VITE_ASSET__DeHXAhwF__"